import { useAuth } from "@/contexts/AuthContext";
import axios from "axios";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { ShieldWarning } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ImpersonateBanner() {
  const { user, refreshUser } = useAuth();
  const navigate = useNavigate();
  if (!user?.impersonated_by) return null;
  const handleExit = async () => {
    try {
      await axios.post(`${API}/admin/exit-impersonate`, {}, { withCredentials: true });
      await refreshUser();
      toast.success("Sessione admin ripristinata");
      navigate("/admin/users");
    } catch (e) {
      toast.error("Errore nel ripristino sessione admin");
    }
  };
  return (
    <div
      data-testid="impersonate-banner"
      className="bg-red-600 text-white px-6 py-2.5 flex items-center justify-between shadow-md sticky top-0 z-50"
    >
      <div className="flex items-center gap-3">
        <ShieldWarning size={20} weight="duotone" />
        <span className="text-sm font-semibold">
          Stai impersonificando <span className="font-bold underline">{user.email}</span>
          {" — admin: "}
          <span className="opacity-90">{user.impersonated_by.admin_email}</span>
        </span>
      </div>
      <button
        data-testid="impersonate-exit-btn"
        onClick={handleExit}
        className="bg-white/20 hover:bg-white/30 transition px-4 py-1.5 rounded-md text-sm font-semibold"
      >
        Esci dall&apos;impersonificazione
      </button>
    </div>
  );
}
